import React, { useEffect, useState } from "react";
import appApi from "../../assets/utils/AppApi";
import CampaignCarousel from "./CampaignCarousel";
import styles from "./Styles/DesktopLanding.module.css";

export default function DesktopBottomBanners() {
  const [banners, setBanners] = useState([]);
  const [status, setStatus] = useState("loading");
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    const controller = new AbortController();
    setStatus("loading");
    appApi.get("/banner/getbyposition/Bottom?page=1&limit=999", { signal: controller.signal })
      .then(({ data }) => {
        if (controller.signal.aborted) return;
        if (!Array.isArray(data.docs)) throw new Error("Invalid banners response");
        const images = [...data.docs].sort((a, b) => b.index - a.index).flatMap(banner => {
          if (banner.type === "Video") return [];
          if (banner.src) return [banner];
          return (banner.srcList || []).filter(item => item.type === "Image" && item.src)
            .map((item, index) => ({ ...banner, _id: `${banner._id}-${index}`, src: item.src }));
        });
        setBanners(images);
        setStatus("ready");
      }).catch(() => { if (!controller.signal.aborted) setStatus("error"); });
    return () => controller.abort();
  }, [attempt]);

  if (status === "ready" && !banners.length) return null;

  return <section id="latest-programs" className={styles.featured} aria-labelledby="latest-programs-title">
    <div className={styles.sectionHeading}><h2 id="latest-programs-title">تازه‌های راه بهشت</h2></div>
    {status === "loading" ? <p role="status">در حال دریافت برنامه‌ها…</p>
      : status === "error" ? <div role="status">دریافت برنامه‌ها ممکن نشد. <button type="button" onClick={() => setAttempt(value => value + 1)}>تلاش دوباره</button></div>
        : <CampaignCarousel campaigns={banners} imageOnly trackId="bottom-banner-track" labelledBy="latest-programs-title" />}
  </section>;
}
